import React from "react";
import { Button, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function FooterSignupForm({ handleEmailChange, handleShow, tokenUser, tokenAdmin, userIdnew }) {
  return (
    <Row className="footer-signup-form">
      <div className="d-flex align-items-start justify-content-center flex-wrap w-100">
        <div className="footer-title-custom">
          <h4 className="fw-semibold fs-5 mb-3 mt-2 me-3 text-dark lh-sm">
            Sign up for News and special offers:
          </h4>
        </div>
        <div className="subscribe-item" style={{ width: "40%" }}>
          <Form className="d-flex gap-3">
            <Form.Group controlId="formBasicEmail" className="w-100">
              <Form.Control
                className="p-2"
                type="email"
                placeholder="Enter Email"
                onChange={handleEmailChange}
              />
            </Form.Group>

            {(tokenUser || tokenAdmin) ? (
              <Button disabled className="signup-btn text-nowrap" variant="primary">
                Sign Up
              </Button>
            ) : (
              <Button
                className="signup-btn text-nowrap"
                onClick={handleShow}
                variant="primary"
              >
                Sign Up
              </Button>
            )}
          </Form>
          <Link to={userIdnew?.id === undefined ? "" : `/profile/${userIdnew?.id}`}>
            <p className="fw-normal text-dark mb-0 mt-2 ms-0" style={{ fontSize: "18px" }}>
              Manage Existing Subscriptions
            </p>
          </Link>
        </div>
      </div>
    </Row>
  );
}
